module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/venue_owner/goal_unmet-fb95056201118543b51b9555fc38bbe2.png";